import {
  BlockQuote as OriginalBlockQuote,
  BlockQuotePlugin,
} from '@syllepsis/plugin-basic'

// Custom schema extending the original BlockQuote schema
class CustomBlockQuote extends OriginalBlockQuote {
  // public name = NAME

  public attrs = {
    class: {
      default: 'blockquote',
    },
  }

  public parseDOM = [
    {
      tag: 'blockquote',
      getAttrs: (dom: HTMLElement) => ({
        class: dom.getAttribute('class') || '',
      }),
    },
  ]

  public toDOM = (node: any) => {
    // Customize the DOM structure here
    return ['blockquote', { ...node.attrs }, 0] as const
  }
}

// Custom plugin using the custom schema
class CustomBlockQuotePlugin extends BlockQuotePlugin {
  // public name = NAME
  public Schema = CustomBlockQuote
}

export default CustomBlockQuotePlugin
